/**
 * Login Fragment - ES6 Module Version
 * Handles login form initialization and GMT offset calculation
 */
import { Events } from '../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Handler Objects
// ============================================================================

const LoginHandlers = {
    /**
     * Calculate and set GMT offset for timezone-aware authentication
     * Called when a login form with gmt_offset field is detected
     */
    initGmtOffset() {
        const gmtOffsetField = document.getElementById('gmt_offset');
        if (gmtOffsetField) {
            // Calculate GMT offset in minutes (negative of JavaScript's getTimezoneOffset())
            // JavaScript returns offset in minutes, negative values are east of UTC (e.g., -360 for CST/UTC-6)
            const offset = -new Date().getTimezoneOffset();
            gmtOffsetField.value = offset;
            console.log(`gmtOffsetField: ${gmtOffsetField.value}`);
        }
    },

    /**
     * Handle email change button click - redirect to login page
     */
    onChangeEmail(e, element) {
        // Keep the page sign-in should return to; HX-Push-Url left it in the address bar.
        const next = new URLSearchParams(window.location.search).get('next');
        window.location.href = '/app/login' + (next ? '?next=' + encodeURIComponent(next) : '');
    }
};

// ============================================================================
// Exports
// ============================================================================

/**
 * Initialize login fragment
 * Called from main.js on DOMContentLoaded
 */
export function initLogin() {
    if (initialized) return;
    initialized = true;

    // Initialize GMT offset on page load
    LoginHandlers.initGmtOffset();

    // Register event handlers
    Events.on('click', 'login-change-email', LoginHandlers.onChangeEmail);

    // Re-initialize GMT offset after HTMX swaps (e.g., email step -> password step)
    document.addEventListener('htmx:afterSwap', () => {
        LoginHandlers.initGmtOffset();
    });
}
